export default {
  title: {
    regular: 'Modificadores normais para produtos',
    meal: 'Crie o seu item de combinado',
    upsell: 'Crie o seu grupo de upsell',
  },
  description: {
    regular:
      'Selecione modificadores a incluir no novo grupo de modificadores, caso já existam noutro grupo. Pode também criar o grupo e adicionar novos modificadores mais tarde.',
    meal: 'Selecione os produtos a incluir no seu item de combinado. Se os produtos ainda não existirem, crie-os na página "Gerir menus". Certifique-se de que o item de combinado está associado aos produtos corretos na secção "Modificadores" do construtor de produtos.',
    upsell:
      'Selecione os produtos a incluir no seu grupo de upsell. Se os produtos ainda não existirem, crie-os na página "Gerir menus". Certifique-se de que o item de upsell está associado aos produtos corretos na secção "Modificadores" do construtor de produtos.',
  },
  fields: {
    name: {
      label: 'Nome',
      placeholder: 'Introduza o nome do grupo de modificadores',
    },
    max_quantity: {
      label: 'Quantidade máxima',
      placeholder: 'Quantidade máxima de modificadores',
    },
    is_required: {
      label: 'Obrigatório',
    },
  },
  labels: {
    visible: 'Visível',
    hidden: 'Oculto',
    multiply: 'Multiplicável',
  },
  buttons: {
    save: 'Guardar',
    close: 'Fechar',
  },
  toasts: {
    modifier_group_got_created: 'Grupo de modificadores criado',
    modifier_group_got_updated: 'Grupo de modificadores atualizado',
  },
};
